import { Component } from '@angular/core';
import { ModalComponent } from '../../../../modal/modal.component';
import { ButtonComponent } from '../../../../button/button.component';
import { ModalService } from '../../../../modal/modal.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-primeiro-acesso',
  standalone: true,
  imports: [ModalComponent, ButtonComponent],
  templateUrl: './primeiro-acesso.component.html',
  styleUrl: './primeiro-acesso.component.scss',
})
export class PrimeiroAcessoComponent {

  constructor(
    private readonly modalService: ModalService,
    private readonly router: Router
  ){}

  cadastrarEscola() {
    this.router.navigateByUrl('/admin/escolas/criar')
    this.modalService.close();
  }
}
